import React from 'react';
import PropTypes from 'prop-types';
import { createUseStyles, Text, Button } from '@Sage/hoi-poi-ui';

import styles from './styles/drawerHeader';

const name = 'DrawerHeader';
const useStyles = createUseStyles(styles, name);

function DrawerHeader({
    isSaving,
    onSaveCreate,
    isSaveDisabled,
    locales = {
        title: 'Title',
        cancel: 'Cancel',
        save: 'Save',
        saveAndCreate: 'Save & Create',
    },
    onCancel = () => {},
    onSave = () => {},
}) {
    const classes = useStyles();

    return (
        <div className={classes.header}>
            <Text type="subtitle1" className={classes.title}>
                {locales.title}
            </Text>

            <div className={classes.headerActions}>
                {locales.cancel && (
                    <Button
                        size="big"
                        type="terciary"
                        className={`${classes.leftButton} drawer-header__cancel__button`}
                        onClick={onCancel}
                    >
                        {locales.cancel}
                    </Button>
                )}
                {onSaveCreate && (
                    <Button
                        size="big"
                        type="terciary"
                        onClick={onSaveCreate}
                        className={`${classes.leftButton} drawer-header__add-create__button`}
                    >
                        {locales.saveAndCreate}
                    </Button>
                )}
                <Button
                    size="big"
                    className={`${classes.saveButton} drawer-header__save__button`}
                    onClick={onSave}
                    isLoading={isSaving}
                    isDisabled={isSaveDisabled}
                >
                    {locales.save}
                </Button>
            </div>
        </div>
    );
}

DrawerHeader.propTypes = {
    locales: PropTypes.shape({
        title: PropTypes.string,
        cancel: PropTypes.string,
        save: PropTypes.string,
        saveAndCreate: PropTypes.string,
    }),
    onCancel: PropTypes.func,
    onSave: PropTypes.func,
};

const component = React.memo(DrawerHeader);

component.displayName = name;

export default component;
